import '@fontsource/noto-sans'
import '@fontsource/zen-old-mincho'
import 'leaflet/dist/leaflet.css'

import { getHomePath, getRootRedirectLocale } from './src/services/language'

export const onInitialClientRender = () => {
  if (typeof window === 'undefined') return

  const { pathname } = window.location

  if (pathname !== '/' && pathname !== '') return

  const target = getHomePath(getRootRedirectLocale())

  if (target !== '/') {
    window.location.replace(target)
  }
}
